import React, { useEffect, useState } from "react";
import { dbAndOutletLevel, DropDownItem, DropDownStateData } from "../../../features/updateGeofence/updateGeofenceTypes";
import {
  TranslationEnum,
  usePortalTranslation,
} from "../../../providers/TranslationProvider";
import { Autocomplete, TextField } from "@mui/material";
import { getDataForTheDropDown } from "../../../features/updateGeofence/updateGeofenceService";
type Props = {
  currentLevel: dbAndOutletLevel;
  higherLevelInputValues: Record<number,DropDownStateData>;
  updateInputValues: (level: dbAndOutletLevel, data: DropDownStateData) => void;
  lastUpdatedLevel: number;
  resetInputValues : (level : number) => void;
};
const DbAndOutletDropDown: React.FC<Props> = ({
  currentLevel,
  higherLevelInputValues,
  updateInputValues,
  lastUpdatedLevel,
  resetInputValues
}) => {
  // const initialValue :DropDownItem  = higherLevelInputValues?.[currentLevel.level]?.data || null;
  const { translate } = usePortalTranslation();
  const [dropdownElements, setDropdownElements] = useState<DropDownItem[]>([]);
  const [selectedValue, setSelectedValue] = useState<DropDownItem | null>(null);
  const init = async () => {
    const data = (await getDataForTheDropDown(currentLevel, higherLevelInputValues));
    data?.sort((a:DropDownItem,b:DropDownItem)=>a.label.localeCompare(b.label));
    setDropdownElements(data);
  }

  useEffect(()=>{
    if(currentLevel.level > lastUpdatedLevel){
       setSelectedValue(null);
       setDropdownElements([])
     }
    //only fetch data if the curent level is greater than the last updated level
    if(currentLevel.level -1 === lastUpdatedLevel)
      init();
  },[higherLevelInputValues,lastUpdatedLevel])
  return (
    <>
            <Autocomplete
                className="updateGeofence-dbAndOutlet-distance-input"
                value={selectedValue}
                onChange={(event, newValue) => {
                  setSelectedValue(newValue);
                  if(newValue)
                    updateInputValues(currentLevel, {data : newValue , level : currentLevel.level});
                  else{
                    resetInputValues(currentLevel.level)
                  }
                }}
                options={dropdownElements}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={translate(TranslationEnum.geofence, currentLevel.label)}
                    />
                )}
            />
        </>
  );
};

export default DbAndOutletDropDown;
